import { render } from "./CloseButton.vue?vue&type=template&id=003a1c4a&scoped=true"
const script = {}

import "./CloseButton.vue?vue&type=style&index=0&id=003a1c4a&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003a1c4a"]])

export default __exports__